import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'

const ConversationClassification = ({ conversation }) => {
    const [covoClassification, setConvoClassification] = useState({})

    useEffect(() => {
        setConvoClassification(conversation)
    }, [conversation])

    const labels = Object.keys(covoClassification);
    const series = Object.values(covoClassification);
const options = {
  chart: { type: "donut" },
  labels: labels,
  dataLabels: {
    enabled: false,
  },
  colors: ["#c5003e", '#F0F0F0', "#FF4D4F"],
  stroke: { width: 0 },
  legend: { show: false },

  plotOptions: {
    pie: {
      donut: {
        size: '70%',
        labels: {
          show: true,
          name: {
            show: true,
            offsetY: -10,
            fontSize: '16px',
            color: '#000',
          },
          value: {
            show: true,
            fontSize: '24px',
            fontWeight: 600,
            color: '#000',
            offsetY: 10,
            formatter: function (val) {
              return `${val}%`;
            },
          },
          total: {
            show: true,
            label: 'Positive',
            fontSize: '16px',
            color: '#000',
            formatter: function () {
              return `${covoClassification?.positive_percent || 0}%`;
            },
          }
        }
      }
    }
  }
};

    return (
        <div className='shadow-custom rounded-3xl p-5 w-full lg:w-1/2'>
            <p className='text-base font-semibold text-black mb-6'>Conversation Classification</p>
            <div className="flex mt-7 flex-col items-center">
                <div className="w-full md:w-2/3">
                    <Chart
                        options={options}
                        series={series}
                        type="donut"
                        width="100%"
                    />
                </div>
                <div className=" flex flex-row items-start gap-3 mt-4 md:mt-0 font-medium">
                    {options.labels.map((label, index) => (
                        <div
                            key={index}
                            className="flex items-center gap-3 text-sm"
                        >
                            <span
                                className="block w-3 h-3 rounded-full"
                                style={{ backgroundColor: options.colors[index] }}
                            ></span>
                            <span>{label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ConversationClassification